import { SliderThumb, type SliderThumbProps } from '@chakra-ui/react';

export type UiSliderThumbProps = SliderThumbProps;

export const UiSliderThumb = SliderThumb;
